import {
  Package,
  Settings,
  LayoutDashboard,
  Cog,
  ChartNoAxesCombined,
  CircleQuestionMark,
  Power,
  ChevronUp,
  Phone as phoneIcon,
} from 'lucide-angular';

export interface SubMenuItem {
  name: string;
  id: string;
}

export interface MenuItem {
  name?: string;
  icon?: any;
  id?: string;
  children?: SubMenuItem[];
  isSeparator?: boolean;
}

export interface MenuItem {
  name?: string;
  icon?: any;
  id?: string;
  children?: SubMenuItem[];
  isSeparator?: boolean;
}

export const SIDEBAR_MENU: MenuItem[] = [
  {
    name: 'Dashboard',
    icon: LayoutDashboard,
    id: 'dashboard',
  },
  {
    name: 'Products',
    icon: Package,
    id: 'products',
  },
  {
    name: 'Brokers',
    icon: Settings,
    id: 'broker-settings',
  },
  {
    name: 'Performance',
    icon: ChartNoAxesCombined,
    id: 'performance-stats',
  },
  {
    name: 'Help',
    icon: CircleQuestionMark,
    id: 'help',
  },
  {
    isSeparator: true,
  },
  {
    name: 'Settings',
    icon: Cog,
    id: 'settings',
  },
  {
    name: 'Contact Us',
    icon: phoneIcon,
    id: 'contact-us',
  },
  //{
  //  name: "Logout",
  //  icon: Power,
  //  id: "logout"
  //},
];
